/*
 * Copyright (c) Funtip GbR 2018.
 * Simon Oldeboershuis, Perry Prust
 */

import { actionCreatorFactory } from 'typescript-fsa';
import { Album } from '../../../services/playlist';

const actionCreator = actionCreatorFactory();

export const SET_ALBUM_LIST = 'SET_ALBUM_LIST';
export const setAlbumList = actionCreator<Album[]>(SET_ALBUM_LIST);

export const SET_ALBUM_SEARCH = 'SET_ALBUM_SEARCH';
export const setAlbumSearch = actionCreator<string>(SET_ALBUM_SEARCH);

export const SET_ALBUM_SEARCH_CURRENT_POS = 'SET_ALBUM_SEARCH_CURRENT_POS';
export const setAlbumSearchCurrentPos = actionCreator<number>(SET_ALBUM_SEARCH_CURRENT_POS);

export const SET_ALBUM_SEARCH_COUNT = 'SET_ALBUM_SEARCH_COUNT';
export const setAlbumSearchCount = actionCreator<number>(SET_ALBUM_SEARCH_COUNT);

export const SEARCH_ALBUM = 'SEARCH_ALBUM';
export const searchAlbum = actionCreator(SEARCH_ALBUM);

export const ALBUM_LIST_FORWARD = 'ALBUM_LIST_FORWARD';
export const albumListForward = actionCreator(ALBUM_LIST_FORWARD);

export const ALBUM_LIST_BACKWARD = 'ALBUM_LIST_BACKWARD';
export const albumListBackward = actionCreator(ALBUM_LIST_BACKWARD);

export const ALBUM_LIST_FAST_FORWARD = 'ALBUM_LIST_FAST_FORWARD';
export const albumListFastForward = actionCreator(ALBUM_LIST_FAST_FORWARD);

export const ALBUM_LIST_FAST_BACKWARD = 'ALBUM_LIST_FAST_BACKWARD';
export const albumListFastBackward = actionCreator(ALBUM_LIST_FAST_BACKWARD);

export const ALBUM_LIST_SEARCH = 'ALBUM_LIST_SEARCH';
export const albumListSearch = actionCreator<string>(ALBUM_LIST_SEARCH);
